module.exports = __webpack_public_path__ + "static/img/u457.e2e0768.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u457.jpg
// module id = 371
// module chunks = 55